<template>
  <div class="d-flex">
    <span
      v-if="item.source"
      class="
        d-flex align-center
        primary white--text
      "
      style="border-top-left-radius: 10px; border-bottom-left-radius: 10px;"
    >
      <h4 class="px-1" style="writing-mode: vertical-rl; transform:scale(-1);">
        {{ references.broadbeanSource[item.source] || item.source }}
      </h4>
    </span>
    <v-card
      rounded="lg"
      elevation="0"
      class="flex-grow-1"
      :loading="isLoading"
    >
      <v-card-text
        class="px-4 px-md-8"
      >
        <v-list
          v-if="item.collaborator"
          dense
          class="d-flex"
          style="gap: 42px;"
        >
          <v-list-item
            class="px-0"
          >
            <v-list-item-icon class="mr-4">
              <v-icon color="primary">
                mdi-account
              </v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>
                {{ collaboratorName(item.collaborator) }}
              </v-list-item-title>
              <v-list-item-subtitle>Prénom</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            class="px-0"
            link
            :href="`tel:${item.collaborator.mobilephone}`"
          >
            <v-list-item-icon class="mr-4">
              <v-icon color="primary">
                mdi-phone
              </v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>
                {{ item.collaborator.mobilephone }}
              </v-list-item-title>
              <v-list-item-subtitle>Mobile</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            class="px-0"
            link
            :href="`mailto:${item.collaborator.email}`"
          >
            <v-list-item-icon class="mr-4">
              <v-icon color="primary">
                mdi-email
              </v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>
                {{ item.collaborator.email }}
              </v-list-item-title>
              <v-list-item-subtitle>E-mail</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            class="px-0"
          >
            <v-list-item-icon class="mr-4">
              <v-icon color="primary">
                mdi-briefcase-outline
              </v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>
                {{ item.ucpaExperience ? 'Oui' : 'Non' }}
              </v-list-item-title>
              <v-list-item-subtitle>Expérience UCPA</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            class="px-0"
          >
            <v-list-item-icon class="mr-4">
              <v-icon color="primary">
                mdi-calendar
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ formatedDate(item.createTime) }}
              </v-list-item-title>
              <v-list-item-subtitle>Postulé le</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="activeWorkspace === 'spontaneous' && formattedDesiredPositions"
            class="px-0"
          >
            <v-list-item-icon class="mr-4">
              <v-icon color="primary">
                mdi-briefcase-search-outline
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ formattedDesiredPositions }}
              </v-list-item-title>
              <v-list-item-subtitle>Poste souhaité</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="activeWorkspace === 'spontaneous'"
            class="px-0"
          >
            <v-list-item-icon class="mr-4">
              <v-icon color="primary">
                mdi-map-marker
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ formattedDesiredCenters }}
              </v-list-item-title>
              <v-list-item-subtitle>Centre souhaité</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            class="px-2"
            style="position: static;"
          >
            <v-tooltip top>
              <template #activator="{ on }">
                <v-btn
                  :color="item.recruiter ? 'light-blue' : 'primary'"
                  icon
                  absolute
                  class="d-absolute top-0 right-0"
                  style="top: 16px; right: 16px;"
                  v-on="on"
                  @click="handleClick(item, 'stared')"
                >
                  <v-icon>
                    {{ item.stared ? 'mdi-star': 'mdi-star-outline' }}
                  </v-icon>
                </v-btn>
              </template>
              <p
                v-if="item.recruiter"
                class="
                  mb-0
                  caption font-weight-bold
                "
              >
                {{ collaboratorName(item.recruiter) }} -
                <span class="font-weight-medium">{{ item.recruiter.email }}</span>
              </p>
              <p
                v-else
                class="
                  mb-0
                  caption font-weight-bold
                "
              >
                {{ item.stared ? 'Fixé': 'Ne pas fixer' }}
              </p>
            </v-tooltip>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-actions
        class="
          d-flex justify-space-between
          px-4 pt-0 pb-4 px-md-8
        "
      >
        <RecruiterStatus
          :item="item"
          @handle-loading="handleLoading"
        />

        <TableAttachments
          :attachments="item.attachments"
          permission="APPLICATION"
        />

        <v-btn
          color="primary"
          :disabled="!canPerformAction('VIEW_APPLICATION')"
          :to="getCandidatureRoute(item.uuid)"
        >
          En savoir
          <v-icon
            right
            dark
          >
            mdi-plus
          </v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import moment from 'moment';

import { requests } from '@/mixins/requests';

import RecruiterStatus from '@/components/application/components/RecruiterStatus.vue';
import TableAttachments from '@/components/application/components/TableAttachments.vue';

export default {
  name: 'ListItemForApplications',
  components: { RecruiterStatus, TableAttachments },
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return { isLoading: false };
  },
  computed: {
    ...mapState([
      'activeWorkspace',
      'references'
    ]),
    ...mapGetters(['canPerformAction']),
    collaboratorName () {
      return collaborator => `${collaborator.firstname} ${collaborator.lastname}`;
    },
    formatedDate () {
      return date => (date ? moment(date * 1000).format('DD-MM-YYYY') : '');
    },
    formattedDesiredPositions () {
      return this.item.position?.name || '';
    },
    formattedDesiredCenters () {
      return this.item.entity?.name || 'Non renseigné';
    }
  },
  methods: {
    async handleClick (input, field) {
      if (!this.canPerformAction('EDIT_APPLICATION')) return;

      switch (field) {
        case 'stared': {
          this.isLoading = true;

          input[field] = !input[field];
          const inputCopyForClick = { ...input };
          this.removeFields(inputCopyForClick);
          const response = await requests.saveApplication({ input: inputCopyForClick, isEditMode: true });

          if (!response.success) {
            this.$store.commit('setSnackbar', { text: 'Erreur lors de l\'enregistrement.', color: 'error' });
          } else {
            this.$store.commit('setSnackbar', { text: 'Enregistrer avec succès.', color: 'success' });
          }

          this.isLoading = false;
          break;
        }
        default:
          break;
      }
    },
    async handleLoading (value) {
      this.isLoading = value;
    },
    removeFields (input) {
      delete input.collaborator;
      delete input.offer;
      delete input.recruiter;
      delete input.notes;
    },
    getCandidatureRoute (uuid) {
      if (this.activeWorkspace === 'spontaneous') {
        return {
          name: 'candidature-spontanee',
          params: { candidatureUuid: uuid }
        };
      }

      return {
        name: this.$route.meta.childRouteName,
        params: { candidatureUuid: uuid }
      };
    }
  }
};
</script>
